const page = "payment-information";
const component = "productSelection";

export const mapBreakdownToProduct: Record<string, string[]> = {
  "Semaglutide - 23": [
    `${page}.${component}.4weeks.st.0`,
    `${page}.${component}.4weeks.st.1`,
    `${page}.${component}.4weeks.st.2`,
    `${page}.${component}.4weeks.st.4`,
  ],
  "Semaglutide - 74": [
    `${page}.${component}.3months.st.0`,
    `${page}.${component}.3months.st.1`,
    `${page}.${component}.3months.st.2`,
    `${page}.${component}.3months.st.4`,
  ],
  "Tirzepatide - 23": [
    `${page}.${component}.4weeks.tr.0`,
    `${page}.${component}.4weeks.tr.1`,
    `${page}.${component}.4weeks.tr.2`,
    `${page}.${component}.4weeks.tr.4`,
  ],
  "Tirzepatide - 74": [
    `${page}.${component}.3months.tr.0`,
    `${page}.${component}.3months.tr.1`,
    `${page}.${component}.3months.tr.2`,
    `${page}.${component}.3months.tr.4`,
  ],
  "Metformin - 23": [
    `${page}.${component}.4weeks.mt.0`,
    `${page}.${component}.4weeks.mt.1`,
    `${page}.${component}.4weeks.mt.2`,
    `${page}.${component}.4weeks.mt.4`,
  ],
  "Metformin - 74": [
    `${page}.${component}.3months.mt.0`,
    `${page}.${component}.3months.mt.1`,
    `${page}.${component}.3months.mt.2`,
    `${page}.${component}.3months.mt.4`,
  ],
  "Tirzepatide OT - 23": [
    `${page}.${component}.4weeks.tr.0`,
    `${page}.${component}.4weeks.tr.1`,
    `${page}.${component}.4weeks.tr.2`,
    `${page}.${component}.4weeks.tr.4`,
  ],
  "Tirzepatide OT - 74": [
    `${page}.${component}.3months.tr.0`,
    `${page}.${component}.3months.tr.1`,
    `${page}.${component}.3months.tr.2`,
    `${page}.${component}.3months.tr.4`,
  ],
  "Semaglutide OT - 23": [
    `${page}.${component}.4weeks.st.0`,
    `${page}.${component}.4weeks.st.1`,
    `${page}.${component}.4weeks.st.2`,
    `${page}.${component}.4weeks.st.4`,
  ],
  "Semaglutide OT - 74": [
    `${page}.${component}.3months.st.0`,
    `${page}.${component}.3months.st.1`,
    `${page}.${component}.3months.st.2`,
    `${page}.${component}.3months.st.4`,
  ],
  "Insurance Weight Loss - 30": [
    `${page}.${component}.4weeks.iwl-ot.0`,
    `${page}.${component}.4weeks.iwl-ot.1`,
    `${page}.${component}.4weeks.iwl-ot.2`,
    `${page}.${component}.4weeks.iwl-ot.3`,
    `${page}.${component}.4weeks.iwl-ot.4`,
  ],
  "Wegovy Pill - 30": [
    `${page}.${component}.4weeks.wp-ot.0`,
    `${page}.${component}.4weeks.wp-ot.1`,
    `${page}.${component}.4weeks.wp-ot.2`,
    `${page}.${component}.4weeks.wp-ot.3`,
    `${page}.${component}.4weeks.wp-ot.4`,
  ],
  "Diabetes - 30": [
    `${page}.${component}.4weeks.db-ot.0`,
    `${page}.${component}.4weeks.db-ot.1`,
    `${page}.${component}.4weeks.db-ot.2`,
    `${page}.${component}.4weeks.db-ot.3`,
  ],
  "Cardiovascular - 30": [
    `${page}.${component}.4weeks.cv-ot.0`,
    `${page}.${component}.4weeks.cv-ot.1`,
    `${page}.${component}.4weeks.cv-ot.2`,
    `${page}.${component}.4weeks.cv-ot.3`,
  ],
};
